import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import SplashScreen from './SplashScreen';
import Step1 from './Step1';
import Step2 from './Step2';
var OnboardingFlow = function () {
    var _a = useState('splash'), stage = _a[0], setStage = _a[1];
    useEffect(function () {
        // show splash for 2 seconds then go to step1
        if (stage === 'splash') {
            var t_1 = setTimeout(function () { return setStage('step1'); }, 2000);
            return function () { return clearTimeout(t_1); };
        }
    }, [stage]);
    if (stage === 'splash')
        return _jsx(SplashScreen, {});
    if (stage === 'step1')
        return _jsx(Step1, { onNext: function () { return setStage('step2'); } });
    return _jsx(Step2, {});
};
export default OnboardingFlow;
